export function canViewModule(state) {
    return (moduleName) => {
        if (!state.user || !state.user.can_view_modules) {
            return false;
        }
        if (moduleName === 'Cerrar sesión' || moduleName === 'Mi Perfil' || moduleName === 'Ayuda' || moduleName === 'Incidencias') {
            return true;
        }
        return state.user.can_view_modules.includes(moduleName);
    };
}

export function canEditModule(state) {
    return (moduleName) => {
        if (!state.user || !state.user.can_edit_modules) {
            return false;
        }
        return state.user.can_edit_modules.includes(moduleName);
    };
}